import Vue from 'vue'
import Vuex from 'vuex'

// Kalimah Store Modules
import config from './store/config'
import messages from './store/messages'
import login from './store/login'
import posts from './store/posts'
import taxonomies from './store/taxonomies'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    config,
    messages,
    login,
    posts,
    taxonomies
  }
})
